
export enum BilledOperationOrganisationSummaryKeys {
    ORGANISATION_ID = "organisationId",
    ORGANISATION_NAME = "organisationName",
    LAST_MONTH_TOTAL = "lastMonthTotal",
    LAST_MONTH_TOTAL_DISPLAY = "lastMonthTotalDisplay",
    CURRENT_MONTH_TO_DATE_TOTAL = "currentMonthToDateTotal",
    CURRENT_MONTH_TO_DATE_TOTAL_DISPLAY = "currentMonthToDateTotalDisplay",
}

export interface BilledOperationOrganisationSummary {
    [BilledOperationOrganisationSummaryKeys.ORGANISATION_ID]: number;
    [BilledOperationOrganisationSummaryKeys.ORGANISATION_NAME]: string;
    [BilledOperationOrganisationSummaryKeys.LAST_MONTH_TOTAL]: number | string;
    [BilledOperationOrganisationSummaryKeys.LAST_MONTH_TOTAL_DISPLAY]: string;
    [BilledOperationOrganisationSummaryKeys.CURRENT_MONTH_TO_DATE_TOTAL]: number | string;
    [BilledOperationOrganisationSummaryKeys.CURRENT_MONTH_TO_DATE_TOTAL_DISPLAY]: string;
}

